import { Row } from 'antd';
import styled from 'styled-components';

export const GreetingContainer = styled(Row)`
  justify-content: center;
  align-items: center;
  padding: 16px;
`;

export const GreetingHand = styled.div`
  margin-right: 8px;
`;

export const GreetingCol = styled.div`
  margin-right: 8px;
`;

export const GreetingHeading = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  margin-bottom: 0px;
`;

export const GreetingRow = styled(Row)`
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`;
